import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import ArrowButton from '../common/button-arrow';
import { getMyProfile, newCustomerNumberAcknowledged } from '../../actions/user';

class NewCustomerNumberPopup extends Component {
  componentDidMount() {
    const { popupActive } = this.props;

    popupActive(true);
  }

  componentWillUnmount() {
    const { popupActive } = this.props;

    popupActive(false);
  }

  handleConfirm = () => {
    const { dispatch, popupActive } = this.props;

    dispatch(newCustomerNumberAcknowledged).then(() => {
      popupActive(false);
      dispatch(getMyProfile('CURRENT_USER_PROFILE'));
    });
  };

  render() {
    const { show, newCustomerNumbers } = this.props;

    return(
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title>New Customer Numbers</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>
              Your new Customer {newCustomerNumbers.length === 1 ? 'Number is' : 'Numbers are'}<br />
              {newCustomerNumbers.map((newCustomerNumber) => <div>{newCustomerNumber}<br/></div>)}
            </p>
            <p>
              Please confirm acknowledgment before continuing to the site.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton
              color="red"
              className="pull-right"
              submit={false}
              arrow={false}
              onClick={this.handleConfirm}
            >
              Confirm
            </ArrowButton>
          </Modal.Footer>
        </Modal>
    );
  }
}

export default connect(null)(NewCustomerNumberPopup);



// WEBPACK FOOTER //
// ./src/components/new-customer-number/new-customer-number-popup.jsx